import { Link } from "react-router-dom";
import { getHotComics, getLatestUpdates } from "@/mocks/comics";

export default function HeroSection() {
  const first = getLatestUpdates()[0];
  const updates = getLatestUpdates().slice(0, 4);

  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=cinematic%20collage%20of%20energetic%20anime%20manga%20characters%20bursting%20with%20warm%20orange%20and%20coral%20energy%2C%20dynamic%20comic%20book%20style%20illustration%2C%20vibrant%20action%20and%20adventure%20mood%2C%20rich%20texture%20with%20speed%20lines%20and%20glowing%20light%2C%20deep%20warm%20background%2C%20high%20detail%20digital%20art&width=1600&height=900&seq=hero-2026-x1&orientation=landscape"
        alt="天天漫画网每日更新连载漫画首屏背景"
        className="absolute inset-0 h-full w-full object-cover opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/70 to-foreground-950/30"></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="max-w-2xl">
          <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-background-200/30 bg-background-50/10 px-3 py-1 text-xs font-medium text-background-50">
            <i className="ri-calendar-check-line text-secondary-400"></i>
            今日 08:30 更新 · 最新话已同步上线
          </p>
          <h1 className="font-heading text-3xl leading-tight text-background-50 md:text-5xl">
            天天漫画网，<br className="hidden sm:block" />
            每日更新<span className="text-primary-400">追更漫画</span>抢先看
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-background-100 md:text-base">
            热门连载漫画每日更新，今日更新最新话同步上线。想看哪部直接搜，连载漫画随时点开随时看，追更漫画不迷路。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/list"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-book-2-fill"></i>开始看漫画
            </Link>
            <Link
              to="/faq"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-200/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              新手怎么用？
            </Link>
          </div>

          <div className="mt-9 grid grid-cols-3 gap-3 border-t border-background-200/20 pt-6">
            {[
              { num: "4800+", label: "连载漫画" },
              { num: "每日更新", label: "最新话同步" },
              { num: "1000万+", label: "追更读者" },
            ].map((s) => (
              <div key={s.label}>
                <p className="font-heading text-xl text-primary-400 md:text-2xl">{s.num}</p>
                <p className="mt-1 text-xs text-background-200">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 pb-14 md:px-6">
        <div className="overflow-hidden rounded-lg border border-background-200/20 bg-background-950/60">
          <div className="flex items-center justify-between border-b border-background-200/20 px-4 py-3">
            <p className="flex items-center gap-2 text-sm font-bold text-background-50">
              <i className="ri-fire-fill text-accent-400"></i>今日最新更新
            </p>
            <Link to="/list" className="text-xs text-background-200 hover:text-background-50">
              查看全部 →
            </Link>
          </div>
          <div className="grid grid-cols-1 divide-y divide-background-200/15 sm:grid-cols-2 sm:divide-y-0">
            {updates.map((c, i) => (
              <Link
                key={c.id}
                to={`/comic/${c.id}`}
                className="flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-50/5"
              >
                <span className="w-4 font-heading text-primary-400">0{i + 1}</span>
                <img src={c.cover} alt={`${c.title}封面`} className="h-14 w-11 rounded object-cover object-top" />
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-bold text-background-50">{c.title}</p>
                  <p className="truncate text-xs text-background-300">{c.latestChapter}</p>
                </div>
                <span className="whitespace-nowrap rounded-full bg-accent-500 px-2 py-0.5 text-xs text-background-50">
                  {c.updateTime}
                </span>
              </Link>
            ))}
          </div>
        </div>
        <span className="sr-only">{first?.title}今日更新</span>
      </div>
    </section>
  );
}